module.exports = __webpack_public_path__ + "assets/drop-pin.f47ca6b71345a5246158263ccb705d36.svg";